﻿﻿export interface IShortCodeLink {
    id: string;
    link: string;
    createdDateTime: Date;
    clickCount: number;
    isActive: boolean;
}
